import { render, staticRenderFns } from "./swipeInfo.vue?vue&type=template&id=33d679f8&scoped=true&"
import script from "./swipeInfo.vue?vue&type=script&lang=js&"
export * from "./swipeInfo.vue?vue&type=script&lang=js&"
import style0 from "./swipeInfo.vue?vue&type=style&index=0&id=33d679f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d679f8",
  null
  
)

export default component.exports